import { setupAxios } from '@carvana/core-auth';
import axios from 'axios';

export default setupAxios(axios.create({ timeout: 30000 }), {
  addBearerTokenToAllRequests: true
});
